// extracted by mini-css-extract-plugin
export var active = "_bv-7";
export var blink = "_bv-8";
export var dropDownSelector = "_bv-4";
export var dropDownWrapper = "_bv-3";
export var fakeCursor = "_bv-6";
export var fontSizeButton = "_bv-9";
export var formQuillEditor = "_bv-0";
export var pressed = "_bv-a";
export var qlBlank = "_bv-1";
export var textFormattingToolbar = "_bv-2";
export var textToolbarOption = "_bv-5";